import React from "react";
import OrderTable from "../Table";

const InvoiceAccepted = () => {
  return <OrderTable type="Invoice Accepted" />;
};

export default InvoiceAccepted;
